import { For, Show } from "solid-js";
import type { QueueListItem } from "@saquei/types";
import { Button, Card, Chip } from "../ui";

interface Props {
    items: QueueListItem[];
    onJoinSolo: () => void;
    onCancel: (id: string) => void;
    onPass: (id: string) => void;
}

export function QueueList(props: Props) {
    return (
        <Card class="dev-queue-card">
            <header class="dev-queue-head">
                <div class="dev-queue-title">
                    <strong>Fila</strong>
                    <Chip size="sm" tone="neutral">{props.items.length}</Chip>
                </div>
                <Button size="sm" variant="primary" onClick={props.onJoinSolo}>
                    + Entrar (solo)
                </Button>
            </header>
            <Show when={props.items.length > 0} fallback={<p class="dev-queue-empty">Fila vazia.</p>}>
                <ul class="dev-queue-list">
                    <For each={props.items}>
                        {(item) => (
                            <li class="dev-queue-item">
                                <span class="pos">#{item.position ?? "?"}</span>
                                <Chip size="sm" tone={item.status === "invited" ? "aguardando" : "neutral"}>
                                    {item.status}
                                </Chip>
                                <Show when={item.invited_court_id}>
                                    <code class="muted">em {item.invited_court_id}</code>
                                </Show>
                                <Show when={item.invite_expires_at}>
                                    <code class="muted">expira {fmtTime(item.invite_expires_at!)}</code>
                                </Show>
                                <span class="dev-queue-spacer" />
                                <Show when={item.status === "invited"}>
                                    <Button size="sm" variant="ghost" onClick={() => props.onPass(item.id)}>
                                        Passar
                                    </Button>
                                </Show>
                                <Button size="sm" variant="ghost" onClick={() => props.onCancel(item.id)}>
                                    Cancelar
                                </Button>
                            </li>
                        )}
                    </For>
                </ul>
            </Show>
        </Card>
    );
}

function fmtTime(iso: string): string {
    return new Date(iso).toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" });
}
